<template>
  <div>
    <section>
      <v-app-bar
        :clipped-left="clipped"
        color="#f3f4f6"
        fixed
        nav
        elevation="0"
        app
        :class="clipped ? 'clipped' : ''"
        style="border-radius: 0px; z-index: 9;">
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="d-flex align-center pl-0"
          :style="clipped ? 'padding-left: 6px;' : ''">
          <div v-if="clipped"
            class="mr-8">
            <v-img
              contain
              width="160"
              height="40"
              alt="kominfoklaten"  
              :src="require('@/assets/logo/logo.png')"
              class="ma-auto cursor-pointer">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    size="20"
                    indeterminate 
                    :color="set_color">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
          <div v-if="clipped">
            <v-btn
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              icon>
              <v-icon
                size="24"
                color="#0e1726">
                {{ !clipped ? 'mdi-chevron-double-left' : 'mdi-menu' }}
              </v-icon>
            </v-btn>
          </div>
  
          <!-- <v-chip
            class="px-3 py-5 font-weight-bold"
            :color="set_color"
            style="border-radius: 50px;"
            text-color="white">
            <div class="d-flex align-center">
              <div>
                Pengajuan Baru 
              </div>
              <div class="ml-2">
                <span style="background-color: #052e46; border-radius: 50px; padding: 3px 9px;">
                  1
                </span>
              </div>
            </div>
          </v-chip>
  
          <v-chip
            class="px-3 py-5 font-weight-bold ml-3"
            color="white"
            style="border-radius: 50px;"
            text-color="black--text">
            <div class="d-flex align-center">
              <div>
                Total pembudidaya 
              </div>
              <div class="ml-2">
                <span style="background-color: #f3f4f6; border-radius: 50px; padding: 3px 9px;">
                  105
                </span>
              </div>
            </div>
          </v-chip> -->
          
          <div v-if="$route.path.split('/')[1] !== 'dashboard' && $route.path.split('/')[1] !== 'profile' && $route.path.split('/')[1] !== 'pengaturan-sistem' && $route.path.split('/')[2] !== 'data-sekolah'">
            <v-autocomplete
              v-on:change="changeSchool()"
    
              solo
              rounded
              dense
              single-line
              v-if="user.school_id === undefined || user.school_id === null"
    
              hide-details
              :color="set_color"
              placeholder="Pilih Sekolah"
              prepend-inner-icon="mdi-magnify"
              :items="school"
              item-text="name"
              item-value="id"
    
              v-model="filter.school_id"
              class="fs-12 little-placeholder ml-0"
              style="border-radius: 6px; background: #fff !important; max-width: 400px">
            </v-autocomplete>
          </div>
        </v-toolbar-title>
  
        <v-spacer/>

        <v-badge
        dot
          color="success"
          offset-x="10"
          offset-y="10"
        >
          <v-btn
            fab
            x-small
            width="36"
            height="36"
            color="#e0e6ed66"
            elevation="0"
            >
            <v-icon color="#0e1726">
              mdi-bell-outline
            </v-icon>
          </v-btn>
        </v-badge>
  
        <div class="ml-3">
          <!-- <v-menu
            transition="slide-x-transition"
            bottom
            right
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-list 
                flat 
                dense
                color="transparent"
                style="max-width: 200px;">
                <v-list-item 
                  v-bind="attrs"
                  v-on="on"
                  class="px-2"
                  style="border-radius: 50px; background: #FFFFFF;">
                  <v-list-item-avatar 
                    size="30"
                    class="mr-3">
                    <v-img 
                      width="100%"
                      height="100%"
                      alt="kominfoklaten"  
                      :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      class="body-2 font-weight-bold">
                      {{ user.name }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-icon>mdi-menu-down</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, index) in menu.right"
                :key="index"
                @click="toMenu(item)">
                <v-list-item-content
                  :style="index < menu.right.length - 1 ? 'border-bottom: 2px solid #f9f9f9;' : ''">
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu> -->
          <v-menu
            transition="slide-x-transition"
            bottom
            right
            min-width="230"
            max-width="230"
            offset-y>
            <template v-slot:activator="{ on, attrs }">

              <v-avatar size="38"
                v-bind="attrs"
                v-on="on">
                <img
                  :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"
                  alt="John"
                >
              </v-avatar>
            </template>
            <v-list two-line class="pt-0">
              <v-list-item>
                <v-list-item-avatar class="my-1">
                  <v-img :src="user.image_url !== undefined && user.image_url !== '' ? user.image_url : require('@/assets/image/member_default.png')"></v-img>
                </v-list-item-avatar>

                <v-list-item-content class="py-1">
                  <v-list-item-title>{{ user.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div style="background-color: #fff;" class="pa-3 pt-0">
              <div class="d-flex align-center mb-2" @click="toMenu({link: '/profile'})" style="cursor: pointer;">
                <div>
                  <v-icon size="18" color="#868b93">mdi-account-circle-outline</v-icon>
                </div>
                <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                  Profile
                </div>
              </div>

              <div class="d-flex align-center">
                <div>
                  <v-icon size="18" color="#868b93">mdi-email-outline</v-icon>
                </div>
                <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px;">
                  Inbox
                </div>
              </div>
            </div>
            <v-divider></v-divider>
            <div style="background-color: #fff;" class="px-3 py-3">
              <div class="d-flex align-center" @click="toLogout" style="cursor: pointer;">
                <div>
                  <v-icon size="18" color="#f5aaae">mdi-logout</v-icon>
                </div>
                <div class="ml-2 fs-14 font_weight_600" style="padding-top: 2px; color: #f5aaae;">
                  Sign Out
                </div>
              </div>
            </div>  
          </v-menu>
        </div>
      </v-app-bar>

      <v-navigation-drawer
        :mini-variant.sync="clipped"
        v-if="!clipped"
        width="260"
        color="#f3f4f6"
        dark
        fixed
        style="
            --tw-shadow: 5px 0 25px 0 rgba(94, 92, 154, .1);
            --tw-shadow-colored: 5px 0 25px 0 var(--tw-shadow-color);
            box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
        "
        app>
        <div
          class="d-flex align-center cursor-pointer pa-3 py-1"
          style="height: 64px; background: #f3f4f6; width: 260px;">
          <!-- <div
            class="d-flex align-center"> -->
            <div v-if="!clipped"
              class="d-flex align-center">
              <v-img
                contain
                width="160"
                height="40"
                alt="kominfoklaten"  
                :src="require('@/assets/logo/logo.png')"
                class="ma-auto ml-1">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <!-- <v-spacer v-if="!clipped" /> -->

            <!-- <v-btn v-if="!clipped"
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              style="position: absolute; right: 0;"
              icon>
              <v-icon
                large
                color="black">
                mdi-chevron-double-left
              </v-icon>
            </v-btn> -->
            <div class="ml-auto" v-if="!clipped">
              <v-btn
                @click="clipped = !clipped ? true : false"
                class="mr-3"
                icon>
                <v-icon
                  size="24"
                  color="#0e1726">
                  {{ !clipped ? 'mdi-chevron-double-left' : 'mdi-menu' }}
                </v-icon>
              </v-btn>

            </div>

            <!-- <v-btn
              @click="clipped = !clipped ? true : false"
              class="mr-3"
              icon>
              <v-icon
                size="24"
                color="#0e1726">
                {{ !clipped ? 'mdi-chevron-double-left' : 'mdi-menu' }}
              </v-icon>
            </v-btn> -->
          <!-- </div> -->
        </div>

        <v-list
          class="pt-0"
          style="height: calc(100vh - 66px); overflow-y: auto; overflow-x: hidden; background-color: #fff;">
          <div 
            v-for="(item, index) in menu"
            :key="index">
            <v-list-item
              v-if="item.sub_menu.length < 1 && item.status" @click="toMenu(item)" class="px-7 mb-1" style="height: 44px !important; min-height: 44px !important; background-color: #f3f4f6;">
              <v-list-item-content>
                <v-list-item-title class="black--text fs-13 text-uppercase" style="font-weight: 700;"
                  >{{ item.label }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>


            <div v-if="item.sub_menu.length > 0 && item.status && item.sub_menu.filter(sub => sub.status === true).length > 0">
              <v-list-item
                v-if="item.status"
                class="px-7 mb-1" style="height: 44px !important; min-height: 44px !important; background-color: #f3f4f6;" @click="item.active = !item.active">
                <v-list-item-content>
                  <v-list-item-title class="black--text fs-13 text-uppercase" style="font-weight: 700;"
                    >{{ item.label }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <v-expand-transition>
                <v-card
                  v-show="item.active"
                  style="background-color: #fff; border-radius: 0px;"
                  flat>
                  <div style="background-color: #fff;">
                    <div
                      v-for="(sub, index) in item.sub_menu"
                      :key="index">
                      <v-list-item
                        :style="sub.link === $route.path ? `color: ${set_color}; font-weight: 500; background-color: #f3f4f6 !important;` : 'color: black;  background-color: #fff !important;'"
                        @click="toMenu(sub)" style="height: 44px !important; min-height: 44px !important; margin: 0px 20px !important; border-radius: 6px !important; padding-right: 10px !important; padding-left: 10px !important; margin-top: 4px; margin-bottom: 4px;"  v-if="sub.sub_menu.length < 1 && sub.status">
                        <v-list-item-avatar tile size="16" class="mr-2">
                          <v-img contain :src="sub.icon"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="fs-13">
                            {{ sub.label }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      
                      <div style="background-color: #fff;" v-if="sub.sub_menu.length > 0 && sub.status && sub.sub_menu.filter(sub => sub.status === true).length > 0">
                        <v-list-group
                          v-model="sub.active"
                          class="sub_sub_menu"
                          :append-icon="sub.active ? 'mdi-chevron-up' : 'mdi-chevron-right'"
                          :class="sub.active ? 'sub_active' : 'sub_non_active'"
                          style="background-color: #fff;">
                          <template v-slot:activator>
                            <v-list-item
                              class="px-3">
                              <v-list-item-avatar tile size="16" class="mr-2">
                                <v-img contain :src="sub.icon"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title class="fs-13" :style="sub.active ? `color: ${set_color}` : 'color: black;'" style="width: 137px;"
                                  >{{ sub.label }}</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <div
                            v-for="(sub2, index) in sub.sub_menu"
                            :key="index">
                            <div v-if="sub2.sub_menu.length < 1 && sub2.status">
                              <v-list-item
                                @click="toMenu(sub2)" class="px-7" style="min-height: 40px; height: 40px; background-color: #fff;  margin: 0px 20px !important; border-radius: 6px !important; padding-right: 10px !important; padding-left: 10px !important; margin-top: 4px; margin-bottom: 4px;"
                                :style="sub2.link === $route.path ? `color: ${set_color}; font-weight: 500; background-color: #f3f4f6 !important;` : 'color: black;  background-color: #fff !important;'">
                                <v-list-item-content>
                                  <v-list-item-title class="fs-12 pl-2"
                                    >
                                    <div class="d-flex align-center">
                                      <v-icon
                                        size="15"
                                        class="mr-1"
                                        :color="sub2.link === $route.path ? set_color : 'black'">
                                        mdi-minus
                                      </v-icon>
                                      <div>
                                        {{ sub2.label }}
                                      </div>
                                    </div>
                                  </v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </div>
                            <div v-if="sub2.sub_menu.length > 0 && sub2.status && sub2.sub_menu.filter(sub => sub.status === true).length > 0">
                              <!-- <v-list-item
                                class="px-3"
                                @click="sub2.active = !sub2.active">
                                <v-list-item-content>
                                  <v-list-item-title class="fs-12 font_weight_600 pl-2"
                                    >
                                    <div class="d-flex align-center">
                                      <v-icon
                                        size="15"
                                        class="mr-1"
                                        :color="'black'">
                                        mdi-minus
                                      </v-icon>
                                      <div>
                                        {{ sub2.label }}
                                      </div>
                                    </div>
                                  </v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item> -->
                              <div style="margin: 4px 20px; background-color: #fff !important;">
                                <div style="height: 40px; padding: 0px 10px;" class="d-flex align-center" :style="sub2.active ? `color: ${set_color}; font-weight: 500; background-color: #f3f4f6 !important; border-radius: 6px;` : 'color: black;  background-color: #fff !important;'">
                                  <div class="d-flex align-center" style="width: 100%; cursor: pointer;" @click="sub2.active = !sub2.active" :style="sub2.active ? `color: ${set_color}; font-weight: 500; background-color: #f3f4f6 !important; border-radius: 6px;` : 'color: black;  background-color: #fff !important;'">
                                    <v-icon
                                      size="15"
                                      class="mr-1 pl-2"
                                      :color="sub2.active ? set_color : 'black'">
                                      mdi-minus
                                    </v-icon>
                                    <div class="fs-12">
                                      {{ sub2.label }}
                                    </div>
                                    <div class="ml-auto">
                                      <v-icon
                                        size="24"
                                        v-if="sub2.active"
                                        class="mr-1"
                                        :color="sub2.active ? set_color : 'black'">
                                        mdi-chevron-down
                                      </v-icon>
                                      <v-icon
                                        size="24"
                                        v-else
                                        class="mr-1"
                                        :color="sub2.active ? set_color : 'black'">
                                        mdi-chevron-right
                                      </v-icon>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <v-expand-transition>
                                <v-card
                                  v-show="sub2.active"
                                  style="background-color: #fff; border-radius: 0px;"
                                  class="pl-2"
                                  flat>
                                  <div
                                    v-for="(sub3, index) in sub2.sub_menu"
                                    :key="index">
                                    <div>
                                      <v-list-item
                                        @click="toMenu(sub3)" class="px-7" style="min-height: 40px; height: 40px; background-color: #fff;  margin: 0px 20px !important; border-radius: 6px !important; padding-right: 10px !important; padding-left: 10px !important; margin-top: 4px; margin-bottom: 4px;"
                                        v-if="sub3.status"
                                        :style="sub3.link === $route.path ? `color: ${set_color}; font-weight: 500; background-color: #f3f4f6 !important;` : 'color: black;  background-color: #fff !important;'">
                                        <v-list-item-content>
                                          <v-list-item-title class="fs-12 pl-2"
                                            >
                                            <div class="d-flex align-center">
                                              <v-icon
                                                size="15"
                                                class="mr-1"
                                                :color="sub3.link === $route.path ? set_color : 'black'">
                                                mdi-minus
                                              </v-icon>
                                              <div>
                                                {{ sub3.label }}
                                              </div>
                                            </div>
                                          </v-list-item-title
                                          >
                                        </v-list-item-content>
                                      </v-list-item>
                                    </div>
                                  </div>
                                </v-card>
                              </v-expand-transition>
                              <!-- <div style="background-color: #fff;" v-if="sub.sub_menu.length > 0">
                                <v-list-group
                                  @click="sub2.active = !sub2.active"
                                  class="sub_sub_menu"
                                  :append-icon="sub2.active ? 'mdi-chevron-up' : 'mdi-chevron-right'"
                                  :class="sub2.active ? 'sub_active' : 'sub_non_active'"
                                  style="background-color: #fff;">
                                  <template v-slot:activator>
                                    <v-list-item
                                      class="px-3">
                                      <v-list-item-content>
                                        <v-list-item-title class="fs-12 font-weight-bold pl-2"
                                          >
                                          <div class="d-flex align-center">
                                            <v-icon
                                              size="15"
                                              class="mr-1"
                                              :color="'black'">
                                              mdi-minus
                                            </v-icon>
                                            <div>
                                              {{ sub2.label }}
                                            </div>
                                          </div>
                                        </v-list-item-title
                                        >
                                      </v-list-item-content>
                                    </v-list-item>
                                  </template>
                                  <div
                                    v-for="(sub3, index) in sub2.sub_menu"
                                    :key="index">
                                    <div>
                                      <v-list-item
                                        @click="toMenu(sub3)" class="px-7" style="background-color: #fff;  margin: 0px 20px !important; border-radius: 6px !important; padding-right: 10px !important; padding-left: 10px !important; margin-top: 4px; margin-bottom: 4px;"
                                        :style="sub3.link === $route.path ? `color: ${set_color}; font-weight: 500; background-color: #f3f4f6 !important;` : 'color: black;  background-color: #fff !important;'">
                                        <v-list-item-content>
                                          <v-list-item-title class="fs-12 font-weight-bold pl-2"
                                            >
                                            <div class="d-flex align-center">
                                              <v-icon
                                                size="15"
                                                class="mr-1"
                                                :color="sub3.link === $route.path ? set_color : 'black'">
                                                mdi-minus
                                              </v-icon>
                                              <div>
                                                {{ sub3.label }}
                                              </div>
                                            </div>
                                          </v-list-item-title
                                          >
                                        </v-list-item-content>
                                      </v-list-item>
                                    </div>
                                  </div>
                                </v-list-group>
                              </div> -->

                            </div>
                          </div>
                        </v-list-group>
                      </div>
                    </div>
                  </div>

                </v-card>
              </v-expand-transition>

            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        unit: [],
        filter: {unit_id: '501'},
        date_password: false,
        filter: {
          school_id: ''
        },
        school: [],
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      menu () {
        let menu = this.$store.state.menu
        menu.map((item, index) => {
          if (item.link.split('/')[1] === this.$route.path.split('/')[1]) {
            if (item.sub_menu.length > 0) {
              item.sub_menu.map((sub, index) => {
                if (sub.link.split('/')[2] === this.$route.path.split('/')[2]) {
                  sub.active = true
                  if (sub.sub_menu.length > 0) {
                    sub.sub_menu.map((sub2, index) => {
                      if (sub2.link.split('/')[3] === this.$route.path.split('/')[3]) {
                        sub2.active = true
                        if (sub2.sub_menu.length > 0) {
                          sub2.sub_menu.map((sub3, index) => {
                            if (sub3.link.split('/')[4] === this.$route.path.split('/')[4]) {
                              sub3.active = true
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            }
          }
        })
        
        return menu
      },
      token () {
        return this.$store.state.token
      },
      reload () {
        return this.$store.state.reload
      },
      // company () {
      //   return this.$store.state.company
      // },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      counter () {
        return this.$store.state.counter
      },

      tahun_anggaran () {
        return this.$store.state.year
      },

      user () {
        this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
        return this.$store.state.user
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    watch: {
    },
    created () {
      
    },
    mounted () {
      console.log(this.$store.state.user)
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()
      // this.fetchDpa()

      // console.log(this.$store.state.menu)
      this.fetchSchool()

    },
    methods: {
      async fetchSchool() {
  
          let params = {
          limit: 10000000000000
        }
        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.school = res.results.data
            if (this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null) {
              if(this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== ''){
                this.filter.school_id = this.$store.state.school
              } else {
                this.filter.school_id = this.school.length > 0 ? this.school[0].id : ''
                this.$store.commit('setSchool', this.filter.school_id)
                TokenService.saveSchool(this.filter.school_id)
              }
            } else {
              this.filter.school_id = this.$store.state.user.school_id
            }
          }
        })
      },
      changeSchool () {
        this.$store.commit('setSchool', this.filter.school_id)
        TokenService.saveSchool(this.filter.school_id)
      },
      async toLogout (item) {
        TokenService.removeToken()
            
        window.location = '/login'
      },

      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            // background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            // background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            // color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            // color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 5px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            // background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      },

      async fetchUnit () {

        let params = {
          limit: 100000,
          year: new Date().getFullYear()
        }
        
        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
            if(this.$route.query.unit !== undefined){
              this.filter.unit_id = this.$route.query.unit

            }
          }
        })
      },

      toMenu (item) {
        this.$router.push(item.link)
      },

      set_year (value) {
        this.$store.commit('setYear', value)
        
        TokenService.saveYear(value)
      }
    }
  }
</script>

<style>
  .sub .v-list-item {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .clipped .v-toolbar__content {
    padding-left: 8px;
  }

  .v-navigation-drawer--mini-variant {
    width: 68px !important;
  }

  .clipped_header .v-list-group__header {
    padding: 0px 13px;
  }
</style>